import { http } from './request';
import {
    BASE_API_URL,
    TG_WIDGET_JWT,
    TG_WIDGET_ACCESS_TOKEN,
    TG_WIDGET_REVIEW_SCHEMES,
    TG_WIDGET_MEMBER_DATA

} from '../config/keys';

export const authenticateAccessToken = (theme: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(TG_WIDGET_ACCESS_TOKEN);

        if (!(accessToken || {}).length) {
            return reject('No access Token');
        }

        const authUrl = `${BASE_API_URL}/authenticate/submission`;

        http.post(authUrl, {
            AccessToken: accessToken,
            'x-theme': theme
        }).then((res: any) => {
            const data = ((res || {}).data || {}).data;

            console.log(data);

            if (!data) {
                throw new Error('Failed to get response from authenticateAccessToken');
            }

            if (!data.jwt) {
                throw new Error('Failed to get JWT from authenticateAccessToken');
            }

            if (!data.reviewSchemeData) {
                throw new Error('Failed to get reviewSchemeData from authenticateAccessToken');
            }

            if (!data.widgetMemberData) {
                throw new Error('Failed to get widgetMemberData from authenticateAccessToken');
            }
            
            localStorage.setItem(TG_WIDGET_JWT, data.jwt);
            localStorage.setItem(TG_WIDGET_MEMBER_DATA, JSON.stringify(data.widgetMemberData));    
            localStorage.setItem(TG_WIDGET_REVIEW_SCHEMES, JSON.stringify(data.reviewSchemeData));

            resolve(data.jwt);

        }).catch((err: any) => {
            resolve(null);
        });
    });
};
